<ion-header parkourAdaptToSidebarVisible>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [parkourBackButton]="['../..']" />
    </ion-buttons>

    <ion-title>{{ 'over-parkour.aan-de-slag-page.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <parkour-page-layout>
    <parkour-page-gradient />
    <ng-container *parkourPageContent="mainPageData$ | async; refresh: onPageRefresh; let data">
      <div class="relative z-10 py-8 container container-space">
        <div class="container-1-col">
          <h1 class="text-center mb-4">{{ 'over-parkour.aan-de-slag-page.title' | translate }}</h1>

          <parkour-divider></parkour-divider>

          <p class="text-center mt-8">
            {{ 'over-parkour.aan-de-slag-page.description' | translate }}
          </p>
          @if (data.profielContent.length > 0) {
            @if (data.profielContent.length > 0) {
              <ng-container
                [ngTemplateOutlet]="instructionSection"
                [ngTemplateOutletContext]="{
                  content: data.profielContent,
                  icon: 'people-3',
                  subtitle: 'over-parkour.aan-de-slag-page.profiel-subtitle',
                  description: 'over-parkour.aan-de-slag-page.profiel-description',
                }"
              ></ng-container>
            }
          }
          @if (data.teamContent.length > 0) {
            @if (data.teamContent.length > 0) {
              <ng-container
                [ngTemplateOutlet]="instructionSection"
                [ngTemplateOutletContext]="{
                  content: data.teamContent,
                  icon: 'people',
                  subtitle: 'over-parkour.aan-de-slag-page.team-subtitle',
                  description: 'over-parkour.aan-de-slag-page.team-description',
                }"
              ></ng-container>
            }
          }
          @if (data.doelenContent.length > 0) {
            @if (data.doelenContent.length > 0) {
              <ng-container
                [ngTemplateOutlet]="instructionSection"
                [ngTemplateOutletContext]="{
                  content: data.doelenContent,
                  icon: 'target',
                  subtitle: 'over-parkour.aan-de-slag-page.doelen-subtitle',
                  description: 'over-parkour.aan-de-slag-page.doelen-description',
                }"
              ></ng-container>
            }
          }
          @if (data.verhaalContent.length > 0) {
            @if (data.verhaalContent.length > 0) {
              <ng-container
                [ngTemplateOutlet]="instructionSection"
                [ngTemplateOutletContext]="{
                  content: data.verhaalContent,
                  icon: 'compass',
                  subtitle: 'over-parkour.aan-de-slag-page.verhaal-subtitle',
                  description: 'over-parkour.aan-de-slag-page.verhaal-description',
                }"
              ></ng-container>
            }
          }
          @if (data.berichtenContent.length > 0) {
            @if (data.berichtenContent.length > 0) {
              <ng-container
                [ngTemplateOutlet]="instructionSection"
                [ngTemplateOutletContext]="{
                  content: data.berichtenContent,
                  icon: 'paper-plane',
                  subtitle: 'over-parkour.aan-de-slag-page.berichten-subtitle',
                  description: 'over-parkour.aan-de-slag-page.berichten-description',
                }"
              ></ng-container>
            }
          }

          @if (data.ondersteuningContent.length > 0) {
            @if (data.ondersteuningContent.length > 0) {
              <ng-container
                [ngTemplateOutlet]="instructionSection"
                [ngTemplateOutletContext]="{
                  content: data.ondersteuningContent,
                  icon: 'life-buoy',
                  subtitle: 'over-parkour.aan-de-slag-page.ondersteuning-subtitle',
                  description: 'over-parkour.aan-de-slag-page.ondersteuning-description',
                }"
              ></ng-container>
            }
          }

          <div class="flex flex-col gap-y-4 mt-20">
            <h2 class="typo-h4">{{ 'over-parkour.aan-de-slag-page.hulp-nodig' | translate }}</h2>

            <parkour-button
              [link]="['..', 'veelgestelde-vragen']"
              iconAfter="chevron-right"
              variant="ghost"
            >
              {{ 'over-parkour.aan-de-slag-page.veelgestelde-vragen' | translate }}
            </parkour-button>
          </div>
        </div>
      </div>
    </ng-container>
  </parkour-page-layout>
</ion-content>

<ng-template
  #instructionSection
  let-content="content"
  let-icon="icon"
  let-subtitle="subtitle"
  let-description="description"
>
  <section class="mt-8">
    <div class="text-center pl-8 pr-8 mb-6">
      <h2 class="typo-h3 text-p-200 text-center mb-1">
        <parkour-icon [name]="icon" />
        {{ subtitle | translate }}
      </h2>
      <p>{{ description | translate }}</p>
    </div>
    <parkour-instruction-content
      [instructions]="content"
      [initiallyActiveItem]="initiallyActiveItem()"
    />
  </section>
</ng-template>
